import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useGoToPageInputValidationSchema = (totalPages: number) => {
  const { t } = useTranslation(['validation']);

  return z.object({
    page: z.coerce
      .number({
        invalid_type_error: t('validation:required'),
      })
      .positive(t('validation:positive'))
      .min(
        1,
        t('validation:minNumber', {
          number: 1,
        }),
      )
      .max(totalPages, t('validation:maxNumber', { number: totalPages })),
  });
};
